const trueIdentifyOption = [
  { label: '正确', value: 1 },
  { label: '不正确，请小妹手动修改登记', value: 0 }
];

const isApproveOption = [
  { label: '全部', value: '' },
  { label: '待审核', value: 0 },
  { label: '通过', value: 1 },
  { label: '不通过', value: 2 }
];

const isApproveMap: Record<string, string> = {
  0: '待审核',
  1: '通过',
  2: '不通过'
};

const DEFAULT_RISK_LEVEL = 'none';

const riskLevelOption = [
  { label: '无风险', value: 'none' },
  { label: '有风险', value: 'all' },
  { label: '高', value: 'high' },
  { label: '中', value: 'medium' },
  { label: '低', value: 'low' }
];

const riskLevelTagMap: Record<string, { label: string; bg: string; text: string }> = {
  high: { label: '高', bg: '#FFECE8', text: '#F53F3F' },
  medium: { label: '中', bg: '#FFF7E8', text: '#FF7D00' },
  low: { label: '低', bg: '#E8F3FF', text: '#165DFF' }
};
// 所有接口走同源前缀，开发由 setupProxy.js 转发，生产由 Nginx /inner-trans/ 转发
// const defaultBaseUrl = 'http://background-prod.fulibiji.com.cn/inner-trans';
const defaultBaseUrl = '/inner-trans';
const baseUrl = (process.env.REACT_APP_API_BASE_URL || defaultBaseUrl).replace(/\/$/, '');

// API 基础配置
const API_CONFIG = {
  // 基础地址（用于 API 请求）
  baseUrl: baseUrl,
  // 文件上传地址
  uploadUrl: baseUrl + '/common/uploadFile',
  videoTranscodeStatusUrl: '/common/videoTranscodeStatus',
  // 导出地址基础路径
  exportBaseUrl: baseUrl
};

/**
 * 手机号脱敏展示：保留前3后4位，中间以 * 替代。
 * 例：13812345678 -> 138****5678
 */
function maskPhone(phone?: string | null): string {
  if (phone == null || phone === '') return '-';
  const str = String(phone).trim();
  if (/^1\d{10}$/.test(str)) {
    return `${str.slice(0, 3)}****${str.slice(7)}`;
  }
  if (str.length >= 7) {
    return `${str.slice(0, 3)}****${str.slice(-4)}`;
  }
  return str;
}

function compactText(text: string): string {
  return text
    .replace(/\r\n?/g, '\n')
    .replace(/[ \t]+/g, ' ')
    .replace(/\n+/g, ' ')
    .trim();
}

function insertToText(insert: unknown): string {
  return typeof insert === 'string' ? insert : '';
}

function deltaToText(delta: unknown): string | null {
  const ops = Array.isArray(delta)
    ? delta
    : delta && Array.isArray((delta as { ops?: unknown }).ops)
      ? (delta as { ops: unknown[] }).ops
      : null;
  if (!ops) return null;
  return ops.map(op => insertToText(op && typeof op === 'object' ? (op as { insert?: unknown }).insert : null)).join('');
}

/** 从 start 处的 { / [ 开始做括号配对，取出第一个完整 JSON 片段 */
function readJsonAt(text: string, start: number): { value: unknown; end: number } | null {
  const stack: string[] = [];
  let inString = false;
  let escaped = false;
  for (let i = start; i < text.length; i += 1) {
    const ch = text[i];
    if (inString) {
      if (escaped) escaped = false;
      else if (ch === '\\') escaped = true;
      else if (ch === '"') inString = false;
      continue;
    }
    if (ch === '"') inString = true;
    else if (ch === '{' || ch === '[') stack.push(ch === '{' ? '}' : ']');
    else if (ch === '}' || ch === ']') {
      if (stack.pop() !== ch) return null;
      if (stack.length === 0) {
        try {
          return { value: JSON.parse(text.slice(start, i + 1)), end: i + 1 };
        } catch {
          return null;
        }
      }
    }
  }
  return null;
}

/**
 * 笔记 content 存的是 Quill Delta JSON，直接渲染会显示成 JSON 串。
 * 只提取文本节点，忽略图片/视频等非文本节点；兼容纯文本、老 HTML，
 * 以及「前缀文字 + Delta JSON」混排的历史数据。
 */
function formatNoteContent(content?: string | null): string {
  if (content == null) return '-';
  let raw = String(content).trim();
  if (!raw) return '-';

  let parsed: unknown;
  try {
    parsed = JSON.parse(raw);
  } catch {
    parsed = undefined;
  }
  // 兼容被二次 JSON 编码的历史数据
  if (typeof parsed === 'string') {
    raw = parsed.trim();
    try {
      parsed = JSON.parse(raw);
    } catch {
      parsed = undefined;
    }
  }

  const parsedText = deltaToText(parsed);
  if (parsedText !== null) {
    return compactText(parsedText) || '-';
  }

  const match = /\{\s*"ops"\s*:/.exec(raw);
  if (match) {
    const embedded = readJsonAt(raw, match.index);
    const embeddedText = embedded ? deltaToText(embedded.value) : null;
    if (embedded && embeddedText !== null) {
      const prefix = raw.slice(0, match.index);
      const suffix = raw
        .slice(embedded.end)
        .replace(/^[\s,\]}"']+/, '')
        .replace(/[\s,\]}"']+$/, '');
      return compactText(`${prefix} ${embeddedText} ${suffix}`) || '-';
    }
  }

  if (raw.startsWith('<')) {
    const text = compactText(
      raw
        .replace(/<br\s*\/?>/gi, ' ')
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;/gi, ' ')
        .replace(/&lt;/gi, '<')
        .replace(/&gt;/gi, '>')
        .replace(/&quot;/gi, '"')
        .replace(/&#39;/g, "'")
        .replace(/&amp;/gi, '&')
    );
    return text || '-';
  }

  return raw;
}

export {
  trueIdentifyOption,
  isApproveMap,
  isApproveOption,
  DEFAULT_RISK_LEVEL,
  riskLevelOption,
  riskLevelTagMap,
  baseUrl,
  API_CONFIG,
  maskPhone,
  formatNoteContent
};
